// eslint-disable-next-line no-unused-vars
import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import useOrder from 'Hooks/useOrder';
import OrderPage from 'Containers/Order/OrderPage';
import NotFound from 'Components/NotFound/NotFound';

const ViewOrder = memo(() => {
  const { t } = useTranslation();
  const { data: order, error, mutate: mutateOrder } = useOrder();

  if (
    order?.error?.code === 'notFound'
    || error?.info?.errors[0].code === 'notFound'
    || !order
  ) {
    return (
      <NotFound
        title={ t('common.oops') }
        description={ t('orders.orderNotFound') }
        buttonText={ t('orders.goToOrdersPage') }
        url="/orders"
      />
    );
  }

  return <OrderPage order={ order } updateOrder={ mutateOrder } />;
});

ViewOrder.displayName = 'ViewOrderContainer';

export default ViewOrder;
